import { DOWNLOAD } from "../constants";

const initialState = {
  totalFiles: null,
  areaGroup: [],
  filterDownload: [],
};

export default function downloadReducer(state = initialState, action) {
  switch (action.type) {
    case DOWNLOAD.SET_TOTATL_FILES:
      return {
        ...state,
        totalFiles: action.payload,
      };
    case DOWNLOAD.SET_AREA_GROUP:
      return {
        ...state,
        areaGroup: action.payload,
      };
    case DOWNLOAD.SET_FILTER_DOWNLOAD:
      return {
        ...state,
        filterDownload: action.payload,
      };
    default:
      return state;
  }
}
